import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

const getMembers = async (params = {}) => {
  const { page = 1, limit = 20, keyword, branchId, roleId, sortBy, sortOrder } = params;
  try {
    return await customFetch(API_ENDPOINTS.ADMIN_MEMBER_LIST, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page, limit, keyword, branchId, roleId, sortBy, sortOrder })
    });
  } catch (error) {
    console.error('メンバー一覧取得エラー:', error);
    throw error;
  }
};

const exportMembers = async (params = {}) => {
  const { keyword, branchId, roleId, sortBy, sortOrder } = params;
  try {
    return await customFetch(API_ENDPOINTS.ADMIN_MEMBER_EXPORT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ keyword, branchId, roleId, sortBy, sortOrder })
    });
  } catch (error) {
    console.error('メンバーエクスポート取得エラー:', error);
    throw error;
  }
};

const getMemberDetail = async (id) => {
  try {
    return await customFetch(API_ENDPOINTS.ADMIN_MEMBER_DETAIL(id), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (error) {
    console.error('メンバー詳細取得エラー:', error);
    throw error;
  }
};

const getBranches = async () => {
  try {
    return await customFetch(API_ENDPOINTS.BRANCHES, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (error) {
    console.error('拠点一覧取得エラー:', error);
    throw error;
  }
};

const addBranch = async ({ name, address, phoneNumber }) => {
  try {
    return await customFetch(API_ENDPOINTS.BRANCHES, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, address, phoneNumber })
    });
  } catch (error) {
    console.error('拠点追加エラー:', error);
    throw error;
  }
};

const updateBranch = async (id, { name, address, phoneNumber, managerId }) => {
  try {
    return await customFetch(`${API_ENDPOINTS.BRANCHES}/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, address, phoneNumber, managerId })
    });
  } catch (error) {
    console.error('拠点編集エラー:', error);
    throw error;
  }
};

const saveExistingMember = async (data) => {
  try {
    return await customFetch(API_ENDPOINTS.ADMIN_MEMBER_REGISTRATION_SAVE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
  } catch (error) {
    console.error('既存メンバー登録エラー:', error);
    throw error;
  }
};

export const adminService = {
  getMembers,
  exportMembers,
  getMemberDetail,
  getBranches,
  addBranch,
  updateBranch,
  saveExistingMember
};
